import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchBVReviewRequest } from '../../actionCreators/bazaarVoiceReview/bazaarVoiceReviewActionCreator'

import Reviews from './Reviews'

export class ReviewsContainer extends Component {
  componentDidUpdate = prevProps => {
    const hasChanged = this.props.partNumber !== prevProps.partNumber
    if (hasChanged) {
      this.getBVReviewData()
    }
  }

  getBVReviewData = () => {
    const { partNumber, requestBVReviewData } = this.props

    const query = {
      Limit: 10,
      Offset: 0,
      Sort: 'SubmissionTime:Desc'
    }
    const payload = {
      partNumber,
      query
    }

    requestBVReviewData(payload)
  }

  render() {
    const reviewCount = this.props.stats.attributes?.reviewCount

    return <>{(reviewCount > 0 || this.props.REVIEWS) && <Reviews {...this.props} />}</>
  }
}

export const mapStateToProps = (state, ownProps) => {
  const { partNumber } = ownProps
  const { bazaarVoiceReview = {} } = state
  const { data = {}, meta = {} } = bazaarVoiceReview
  const { productReviews = {}, stats = {}, allFetchedReviews = [], sortOrder } = data
  const reviews = productReviews[partNumber] || ownProps.reviews || []
  const error = meta[partNumber] || {}

  const props = {
    ...ownProps,
    reviews,
    stats,
    allFetchedReviews,
    sortOrder,
    hasError: error.errorDetail
  }
  return props
}

const mapDispatchToProps = dispatch => {
  const requestBVReviewData = payload => dispatch(fetchBVReviewRequest(payload))

  const props = { requestBVReviewData }
  return props
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewsContainer)
